import type { FaireProductEntity } from "../../entity_types/product";

export const p_48ltjrzo: FaireProductEntity = {
  token: "p_48ltjrzo",
  type: "product",
  name: "Birthday Dots Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d382a5842af185a10ef6eb9eef04c5aed9d937c04847d071dbe2a6c3c37b48e9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/5d300b51e63750003174256c609d19b46632a603cf3048c72d994acf1b5fc806/1528335537.png",
    "https://cdn.faire.com/fastly/1d3529a117e15e8cc27f2a99c887cbbf9a49be86cafd60bf45ea8164faf18bad.png",
    "https://cdn.faire.com/fastly/234774bb49bb653e702b32fe61ea7950dc73b97eb95305a5d87d8529b2f68002.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:42.506Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
